import { render, staticRenderFns } from "./SyncStatus.vue?vue&type=template&id=fabacace&scoped=true"
import script from "./SyncStatus.vue?vue&type=script&lang=js"
export * from "./SyncStatus.vue?vue&type=script&lang=js"
import style0 from "./SyncStatus.vue?vue&type=style&index=0&id=fabacace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabacace",
  null
  
)

export default component.exports